export default __webpack_public_path__ + "e61a8051d0dea68f1c82e348ed990550.png";